class MMLoadMore {
	constructor() {
		this.loadMoreBtn = null;
		this.productGrid = null;
		this.productCount = null;
		this.isLoading = false;
		this.observer = null;
		this.abortController = null;

		this.init();
	}

	init() {
		// Cleanup previous observer if exists
		if (this.observer) {
			this.observer.disconnect();
		}

		// Annule toute requête "load more" encore en vol (ex: déclenchée avant un filtrage)
		// pour qu'elle ne vienne pas ajouter des produits obsolètes à une grille filtrée entre-temps
		if (this.abortController) {
			this.abortController.abort();
			this.abortController = null;
		}
		this.isLoading = false;

		// Get fresh references to DOM elements
		this.loadMoreBtn = document.getElementById("load-more-btn");
		this.productGrid = document.getElementById("product-grid");
		this.productCount = document.getElementById("product-count");

		// Only setup if button exists
		if (!this.loadMoreBtn) {
			return;
		}

		// Remove any existing event listeners by cloning the button
		const newBtn = this.loadMoreBtn.cloneNode(true);
		this.loadMoreBtn.parentNode.replaceChild(newBtn, this.loadMoreBtn);
		this.loadMoreBtn = newBtn;

		// Keep manual click option
		this.loadMoreBtn.addEventListener("click", () => this.loadMoreProducts());

		// Set up Intersection Observer for auto-load
		this.setupInfiniteScroll();
	}

	setupInfiniteScroll() {
		const options = {
			root: null,
			rootMargin: '200px', // Trigger 200px before the button becomes visible
			threshold: 0
		};

		this.observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting && !this.isLoading) {
					this.loadMoreProducts();
				}
			});
		}, options);

		this.observer.observe(this.loadMoreBtn);
	}

	async loadMoreProducts() {
		if (this.isLoading) return;

		this.isLoading = true;
		this.abortController = new AbortController();
		const currentPage = parseInt(this.loadMoreBtn.dataset.page);
		const nextPage = currentPage + 1;
		const collection = this.loadMoreBtn.dataset.collection;
		const sectionId = this.loadMoreBtn.dataset.sectionId;

		// Update button state
		const originalText = this.loadMoreBtn.textContent;
		this.loadMoreBtn.textContent = "Chargement...";
		this.loadMoreBtn.disabled = true;

		try {
			// Get current URL parameters to maintain filters
			const urlParams = new URLSearchParams(window.location.search);
			urlParams.set("page", nextPage);
			urlParams.set("section_id", sectionId);

			const response = await fetch(`${window.location.pathname}?${urlParams.toString()}`, {
				signal: this.abortController.signal
			});
			const html = await response.text();

			// Si un filtrage a entre-temps réinitialisé la grille (init() a annulé ce controller
			// et supprimé le bouton), ne pas injecter ces résultats devenus obsolètes
			if (!this.loadMoreBtn) {
				return;
			}

			const parser = new DOMParser();
			const doc = parser.parseFromString(html, "text/html");
			const newProductGrid = doc.getElementById("product-grid");
			const newProductCount = doc.getElementById("product-count");
			const newLoadMoreBtn = doc.getElementById("load-more-btn");

			if (newProductGrid && newProductGrid.children.length > 0) {
				// Store reference to new products before moving them to DOM
				const newProducts = Array.from(newProductGrid.children);
				
				// Add new products to the grid
				newProducts.forEach((product) => {
					this.productGrid.appendChild(product);
				});

				// Initialize product forms for the newly added products
				// This prevents default form submission that redirects to cart
				newProducts.forEach((productCard) => {
					if (typeof window.mmSetupProductFormForSection === 'function') {
						window.mmSetupProductFormForSection(productCard);
					}
					if (typeof window.mmSetupProductCardVariantsForSection === 'function') {
						window.mmSetupProductCardVariantsForSection(productCard);
					}
				});
				
				// Fallback to global initialization if section-specific function doesn't exist
				if (typeof window.mmSetupProductFormForSection !== 'function' && typeof mmSetupProductForm === 'function') {
					mmSetupProductForm();
				}

				// Update product count
				if (newProductCount) {
					this.productCount.textContent = newProductCount.textContent;
				}

			// Update button state
			this.loadMoreBtn.dataset.page = nextPage;

			// Check if there are more products to load
			if (newLoadMoreBtn) {
				this.loadMoreBtn.textContent = newLoadMoreBtn.textContent;
				this.loadMoreBtn.disabled = false;
				
				// Disconnect and reconnect observer for the updated button
				if (this.observer) {
					this.observer.disconnect();
					this.observer.observe(this.loadMoreBtn);
				}
			} else {
				// No more products to load
				if (this.observer) {
					this.observer.disconnect();
				}
				this.loadMoreBtn.style.display = "none";
			}
		} else {
			// No more products found
			if (this.observer) {
				this.observer.disconnect();
			}
			this.loadMoreBtn.style.display = "none";
		}
		} catch (error) {
			// Ne pas logger ni afficher d'erreur quand la requête a été annulée volontairement
			// (ex: un filtrage a été déclenché pendant que ce chargement était en cours)
			if (error.name !== "AbortError") {
				console.error("Erreur lors du chargement des produits:", error);
				// Re-check if button still exists after potential DOM updates
				const btn = document.getElementById("load-more-btn");
				if (btn) {
					btn.textContent = "Erreur - Réessayer";
					btn.disabled = false;
				}
			}
		}

		this.isLoading = false;
	}
}

// Initialize when DOM is loaded and expose globally for reinitialization
let mmLoadMoreInstance;

document.addEventListener("DOMContentLoaded", () => {
	mmLoadMoreInstance = new MMLoadMore();
});

// Global function to reinitialize after filter changes
window.reinitMMLoadMore = function() {
	if (mmLoadMoreInstance) {
		mmLoadMoreInstance.init();
	}
};
